import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import {mapToObjectDDL} from "../../../common/mapper";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment/moment";
import FlexView from "react-flexview";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {compareArray} from "../util";

class MasterBBNFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSamsat: [],
            dataVariant: [],
        };
    }

    componentDidMount = async () => {
        let {dataSamsat, dataVariant} = this.props;
        this.setState({dataSamsat, dataVariant});
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        let currSamsat = this.props.filterData?.kodeSamsat?.map(i => i.value) || [];
        let currVariant = this.props.filterData?.kodeVariant?.map(i => i.value) || [];
        let prevSamsat = prevProps.filterData?.kodeSamsat?.map(i => i.value) || [];
        let prevVariant = prevProps.filterData?.kodeVariant?.map(i => i.value) || [];
        let {dataSamsat, dataVariant} = this.state;
        let samsatOptions = dataSamsat.map(i => i.value) || [];
        let variantOptions = dataVariant.map(i => i.value) || [];

        if (compareArray(currSamsat, prevSamsat)) {
            if (!currSamsat.includes("ALL") && !R.isEmpty(currSamsat) && samsatOptions.includes("ALL")) {
                dataSamsat.splice(0, 1);
            } else if (R.isEmpty(currSamsat)) {
                dataSamsat.unshift(mapToObjectDDL("ALL", "ALL"));
            }
            this.setState({dataSamsat: dataSamsat});
        }

        if (compareArray(currVariant, prevVariant)) {
            if (!currVariant.includes("ALL") && !R.isEmpty(currVariant) && variantOptions.includes("ALL")) {
                dataVariant.splice(0, 1);
            } else if (R.isEmpty(currVariant)) {
                dataVariant.unshift(mapToObjectDDL("ALL", "ALL"));
            }
            this.setState({dataVariant: dataVariant});
        }
    }

    handleInputDateChange = (name, value) => {
        let parseValue = M(value).format("DD-MM-YYYY");
        this.props.onValueChange(name, parseValue);
    };

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Filter"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    styles={{
                        width: "70%",
                    }}
                    content={
                        <ModalContainer>
                            <SimpleInput
                                id="input_text_nama_lokasi"
                                name="bbnName"
                                label="Nama Tabel BBN"
                                value={this.props.filterData.bbnName}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>Periode</h4>
                            </div>
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleDate
                                    id="select_date_start_date"
                                    name="startDate"
                                    nextdate
                                    date={this.props.filterData.startDate}
                                    maxDate={this.props.filterData?.endDate}
                                    onChange={(value) => this.handleInputDateChange("startDate", value)}
                                />
                                <span className="margin-bottom-20px">-</span>
                                <SimpleDate
                                    id="select_date_end_date"
                                    name="endDate"
                                    backdate
                                    disabled={R.isNil(this.props.filterData?.startDate)}
                                    minDate={this.props.filterData?.startDate}
                                    date={this.props.filterData.endDate}
                                    onChange={(value) => this.handleInputDateChange("endDate", value)}
                                />
                            </FlexView>

                            <SimpleDDL
                                id="select_options_samsat"
                                name="kodeSamsat"
                                label="SAMSAT Berlaku"
                                box="multiselect"
                                options={this.state.dataSamsat}
                                value={this.props.filterData.kodeSamsat}
                                onChange={(value, {name}) =>
                                    this.props.onValueChange(name, value)
                                }
                            />

                            <SimpleDDL
                                id="select_options_kode_variant"
                                name="kodeVariant"
                                label="Varian"
                                box="multiselect"
                                options={this.state.dataVariant}
                                value={this.props.filterData.kodeVariant}
                                onChange={(value, {name}) =>
                                    this.props.onValueChange(name, value)
                                }
                            />

                            <div style={{textAlign: "center"}}>
                                <SimpleButton
                                    secondary
                                    type="button"
                                    text="Hapus"
                                    onClick={() => this.props.onClearFilter()}
                                />
                                <SimpleButton
                                    type="button"
                                    text="Terapkan"
                                    onClick={() => this.props.onSubmit()}
                                />
                            </div>
                        </ModalContainer>
                    }
                />

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default MasterBBNFilter;